import { gql } from '@apollo/client';

export const UPDATE_PRODUCT = gql`
  mutation updateProduct(
    $id: ID!
    $name: String!
    $sku: String
    $uom: UnityOfMeasure!
    $description: String
    $supplierId: ID!
  ) {
    updateProduct(
      id: $id
      input: {
        name: $name
        sku: $sku
        uom: $uom
        description: $description
        supplierId: $supplierId
      }
    ) {
      id
      name
      type
      sku
      uom
      description
      supplier {
        id
        name
        description
        location {
          location
          lat
          lng
        }
        phone
      }
      createdBy {
        id
        firstName
        lastName
        email
        type
      }
      createdAt
      updatedBy {
        id
        firstName
        lastName
        email
        type
      }
      lastUpdate
    }
  }
`;
